<template>
  <div>
    <template v-if="showActionControls">
      <div
        class="pa-3"
        v-for="c in contexts"
        v-show="c.groupId === group.id"
        :key="c.id"
      >
        <action-pre-screen-controls
          :context="c"
          :actionData="actionData"
          @update="updateAction(c)"
          @close="closeAction(c)"
        />
      </div>
    </template>

    <portal to="receivedAction">
      <action-pre-screen-content
        v-if="showActionContent(receivedState)"
        :class="actionContentClass"
        :state="receivedState"
        @send="sendQuestionnaire"
      />
    </portal>
  </div>
</template>

<script>
import GenericAction from '../GenericAction';
import { mapActions, mapState } from 'vuex';

import ActionPreScreenControls from '@/components/rooms/actions/questionnaire/ActionPreScreenControls';
import ActionPreScreenContent from '@/components/rooms/actions/questionnaire/ActionPreScreenContent';
import analyticSender from '@/components/rooms/helpers/analyticSender';

export default {
  name: 'ActionPostScreen',
  mixins: [GenericAction],
  components: {
    ActionPreScreenControls,
    ActionPreScreenContent,
  },
  data() {
    return {
      receivedState: {},
    };
  },
  computed: {
    ...mapState('rooms', ['questionnaireAnswers']),
  },
  methods: {
    ...mapActions('rooms', ['updateQuestionnaireAnswers']),
    selected() {
      this.addContext({
        show: false,
        questionnaire: '',
        introVideo: null,
        outroVideo: null,
        outroAudio: null,
        showMedia: false,
      });
    },

    updateAction(context) {
      this.api.trigger('stateChange', { contexts: this.contexts });
      this.updateParticipants(context);
    },

    sendQuestionnaire(data) {
      analyticSender('submitted_questions', {
        questionnaire: JSON.parse(JSON.stringify(data.answer || {})), // remove vue object
        questionnaireName: data.title,
      });

      this.hostParticipants.forEach((part) => {
        setTimeout(() => this.sendActionTo(part, data));
      });
    },

    received(data) {
      if (data.answer) {
        this.updateQuestionnaireAnswers(data);
      }

      this.receivedState = data;
    },
  },
};
</script>
